import React from "react";
import XponentialPlusModule from "./xponentialPlus/index";
import OnDemandRevenueModule from "./onDemandRevenue/index";
import PageWithConfigurator from "../global/pageWithConfigurator/pageWithConfigurator";

const pageConfig = {
  pageName: "Subscription Sales",
  moduleList: [XponentialPlusModule, OnDemandRevenueModule],
  hideConfigurator: true
};

const SubscriptionSalesPage = ({ notifications }) => {
  return <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />;
};

export default SubscriptionSalesPage;
